import React from 'react';

export function ConnectionsTab({ formData, setFormData, twilioTestLoading, twilioTestResult, testTwilioConfig }) {
  return (
    <div className="space-y-6">
      <div className="p-5 bg-gray-50 rounded-lg border border-gray-200">
        <h4 className="font-medium text-gray-800 mb-4 flex items-center gap-2"><span>📞</span> Twilio Konfiguration</h4>
        <p className="text-sm text-gray-500 mb-4">Verbinden Sie Ihren Twilio-Account, um Anrufe zu empfangen und zu tätigen.</p>
        <div className="grid grid-cols-2 gap-4">
          <div className="col-span-2">
            <label className="block text-sm font-medium text-gray-700 mb-1">Telefonnummer (Twilio)</label>
            <input type="text" placeholder="+49..." value={formData.phone_number} onChange={(e) => setFormData({ ...formData, phone_number: e.target.value })} className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500" />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Account SID</label>
            <input type="text" placeholder="AC..." value={formData.twilio_config?.account_sid || ''} onChange={(e) => setFormData({ ...formData, twilio_config: { ...formData.twilio_config, account_sid: e.target.value } })} className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500" />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Auth Token</label>
            <input type="password" placeholder="••••••••" value={formData.twilio_config?.auth_token || ''} onChange={(e) => setFormData({ ...formData, twilio_config: { ...formData.twilio_config, auth_token: e.target.value } })} className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500" />
          </div>
        </div>

        {/* Connection Status */}
        <div className={`mt-4 p-3 rounded-lg flex items-center gap-2 ${formData.twilio_config?.account_sid && formData.twilio_config?.auth_token ? 'bg-green-50 text-green-700' : 'bg-amber-50 text-amber-700'}`}>
          <span>{formData.twilio_config?.account_sid && formData.twilio_config?.auth_token ? '✓' : '⚠️'}</span>
          <span className="text-sm">{formData.twilio_config?.account_sid && formData.twilio_config?.auth_token ? 'Twilio Credentials konfiguriert' : 'Twilio Credentials erforderlich für Anrufe'}</span>
        </div>

        {/* Test Button */}
        <button onClick={testTwilioConfig} disabled={twilioTestLoading || (!formData.twilio_config?.account_sid)} className="mt-3 px-4 py-2 text-sm border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50 transition-colors disabled:opacity-50 disabled:cursor-not-allowed flex items-center gap-2" data-testid="test-twilio-btn">
          {twilioTestLoading ? (<><svg className="animate-spin h-4 w-4" viewBox="0 0 24 24"><circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" fill="none" /><path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z" /></svg>Teste...</>) : (<>🔌 Verbindung testen</>)}
        </button>

        {/* Test Result */}
        {twilioTestResult && (
          <div className={`mt-3 p-3 rounded-lg text-sm ${twilioTestResult.success ? 'bg-emerald-50 border border-emerald-200 text-emerald-800' : 'bg-red-50 border border-red-200 text-red-800'}`}>
            <div className="flex items-start gap-2">
              <span className="text-lg">{twilioTestResult.success ? '✅' : '❌'}</span>
              <div>
                <p className="font-medium">{twilioTestResult.message}</p>
                {twilioTestResult.details?.account_name && <p className="text-xs mt-1 opacity-75">Account: {twilioTestResult.details.account_name}</p>}
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
